import { SharedUtils } from "../utilities/shared-utils";

export class CitizenInfo {
    id: number | undefined;
    statusId: number | undefined;
    fiscalCode: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    gender: string | undefined;
    dateBirth: Date | undefined;
    municipalityCodeOfBirth: string | undefined;
    phoneCountryCode: string | undefined;
    phoneNumber: string | undefined;
    companyName: string | undefined;
    vatNumber: string | undefined;
    billingSdiCode: string | undefined;

    public static parseCitizenInfo(stringifiedCitizenInfo: CitizenInfo): CitizenInfo {

        let newCitizenInfo: CitizenInfo = new CitizenInfo();

        if(SharedUtils.inputValueIsEmpty(stringifiedCitizenInfo)) {
            return newCitizenInfo;
        }
        newCitizenInfo.id = stringifiedCitizenInfo.id;
        newCitizenInfo.statusId = stringifiedCitizenInfo.statusId;
        newCitizenInfo.fiscalCode = stringifiedCitizenInfo.fiscalCode;
        newCitizenInfo.name = stringifiedCitizenInfo.name;
        newCitizenInfo.surname = stringifiedCitizenInfo.surname;
        newCitizenInfo.gender = stringifiedCitizenInfo.gender;
        newCitizenInfo.dateBirth = stringifiedCitizenInfo.dateBirth;
        newCitizenInfo.municipalityCodeOfBirth = stringifiedCitizenInfo.municipalityCodeOfBirth;
        newCitizenInfo.phoneCountryCode = stringifiedCitizenInfo.phoneCountryCode;
        newCitizenInfo.phoneNumber = stringifiedCitizenInfo.phoneNumber;
        newCitizenInfo.companyName = stringifiedCitizenInfo.companyName;
        newCitizenInfo.vatNumber = stringifiedCitizenInfo.vatNumber;
        newCitizenInfo.billingSdiCode = stringifiedCitizenInfo.billingSdiCode;
        // newCitizenInfo.shippingAddress = this.parseCitizenAddressInfo(stringifiedCitizenInfo.shippingAddress);
        // newCitizenInfo.billingAddress = this.parseCitizenAddressInfo(stringifiedCitizenInfo.billingAddress);
       //  newCitizenInfo.citizenAddressesInfo = stringifiedCitizenInfo.citizenAddressesInfo;

        return newCitizenInfo;
    }
}